import createHistory from 'history/createBrowserHistory';

let history = createHistory();
// window.history_obj  = history;
let callbacks = {};

history.navigate = (url) => {
	for (let i in callbacks) {
		if (typeof callbacks[i] === 'function') {
			callbacks[i](url);
		}
	}
	setTimeout(() => {
		history.push(url);
	}, 400);
};

history.onChange = (callback) => {
	let id = Date.now();
	callbacks[id] = callback;
};
export default history;



// WEBPACK FOOTER //
// ./src/history.js